import dayjs from 'dayjs'
import { EVENT } from '~/configs/page-url'
import { DATE_TIME_FORMAT } from '~/constants'

let timeOut: ReturnType<typeof setTimeout> | null = null
const TIMEOUT = 2000
const STORAGE_KEYS = {
  FLOATING_ORDER: 'floating-event-order',
  FLOATING_DATE: 'floating-event-date'
}

export const useFloating = () => {
  const isShowFloating = ref(true)
  const route = useRoute()

  const getFloatingHiddenCount = (): number => {
    const raw = localStorage.getItem(STORAGE_KEYS.FLOATING_ORDER)
    return raw ? Number(raw) : 0
  }

  const closeFloating = (): void => {
    const count = getFloatingHiddenCount()
    localStorage.setItem(STORAGE_KEYS.FLOATING_ORDER, String(count + 1))
    isShowFloating.value = false
  }

  const resetFloatingCountIfNewDay = (today: string): void => {
    const lastDate = localStorage.getItem(STORAGE_KEYS.FLOATING_DATE)

    if (lastDate !== today) {
      localStorage.setItem(STORAGE_KEYS.FLOATING_DATE, today)
      localStorage.removeItem(STORAGE_KEYS.FLOATING_ORDER)
    }
  }

  const shouldHideFloating = (count: number, isEventPage: boolean): boolean => count >= 3 || isEventPage

  watch(
    () => route.path,
    () => {
      const today = dayjs().format(DATE_TIME_FORMAT.SHORT_DATE_FORMAT)
      const count = getFloatingHiddenCount()
      const isOnEventPage = route.path === EVENT.PREMIER_LEAGUE_RANKING

      resetFloatingCountIfNewDay(today)

      if (shouldHideFloating(count, isOnEventPage)) {
        isShowFloating.value = false
      } else {
        timeOut = setTimeout(() => {
          isShowFloating.value = true
        }, TIMEOUT)
      }

      return () => {
        if (timeOut) {
          clearTimeout(timeOut)
        }
      }
    },
    { immediate: true }
  )

  return {
    isShowFloating,
    closeFloating
  }
}
